import { Component, OnInit } from "@angular/core";
import { AuthService } from "./auth/auth.service";
import { MigrationStore } from "./services/migration.store";
import { PlaceHolder } from "./interface/interfaces";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: false,
})
export class AppComponent implements OnInit {
  isAuthenticated$ = this.authService.isAuthenticated$;
  username$ = this.authService.username$;
  userPhotoUrl$ = this.authService.userPhotoUrl$;
  isDarkMode = false;

  constructor(
    public authService: AuthService,
    public store: MigrationStore,
  ) {}

  ngOnInit(): void {}

  login() {
    this.authService.login();
  }

  logout() {
    this.authService.logout();
  }

  getPlaceHolderValue(placeHolderName: string): string {
    const placeHolders = this.store.placeHolders();
    const placeholder = placeHolders?.find(
      (placeHolder: PlaceHolder) =>
        placeHolder.place_holder_name === placeHolderName,
    );

    return (
      `${placeholder?.place_holder_name.replace("_", "")} ${placeholder?.place_holder_value}` ||
      ""
    );
  }
}
